module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5RNuQr/tc-custom/CoverDesign.jpg?1684514528242?1685556933279",
      "alt": "This image is the cover for the book Rage to Live, Finding the Strength"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rage to Live, Finding the Strength\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Finding the Strength: Book One")])])]), _c('p', [_vm._v("Can a young woman reveal her traumatic past to the woman who wants her to release the bubbling rage inside… her rage to live?")]), _vm._v(" "), _c('p', [_vm._v("Charlie is attempting to start over after a horrifying, life-altering event pushed her and her family to the breaking point. Living with relatives in a different state might be her chance at something normal, something better.")]), _vm._v(" "), _c('p', [_vm._v("Charlie may be broken, but she’s a survivor. Even retaking her senior year of high school doesn’t seem so daunting with the support of her cousins, who attend the local university. She finds herself on the road to recovery as her panic attacks vanish, thanks to the vivacious Arielle Forest, president of a popular sorority on campus and daughter of the dean. Arielle is no stranger to attention, drawing Charlie in with her positive attitude. But their new, tenuous relationship comes with a price that scares Charlie. What if Arielle can’t accept how deep Charlie’s scars run? Or the past that catches up with her? Charlie’s anxiety flares, and the temptation to add a matching scar to her right wrist is strong.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Shirley Anne Edwards\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harmony Ink Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0